import React from "react";

const TermsAndConditions = () => {
  return (
    <div style={{ maxWidth: 800, margin: "auto", padding: 20 }}>
      <h1>Terms and Conditions</h1>

      <section>
        <h2>TL;DR</h2>
        <p>
          C0dify is a free platform aimed at supporting social welfare by providing accessible coding contests. Users must follow the rules, respect others, and play fair. We do not tolerate cheating or misuse. Your data is handled responsibly. We reserve the right to suspend/ban accounts for violations.
        </p>
      </section>

      <section>
        <h2>1. Eligibility</h2>
        <p>Users must be 13 or older and provide accurate information to register.</p>
      </section>

      <section>
        <h2>2. Account Responsibility</h2>
        <p>Keep your account credentials secure. You are responsible for all activity on your account.</p>
      </section>

      <section>
        <h2>3. Usage Rules</h2>
        <p>
          Use the platform as intended. No cheating, plagiarism, bots, multiple accounts, or disruptive behavior.
        </p>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>
          Content on C0dify is owned or licensed by us. Users retain rights to their submissions but grant C0dify a license to use them for platform operations.
        </p>
      </section>

      <section>
        <h2>5. Data Privacy</h2>
        <p>
          We collect and process data as described in our Privacy Policy. We do not sell your personal data.
        </p>
      </section>

      <section>
        <h2>6. Prohibited Activities</h2>
        <p>
          Use of automated scripts, bots, or any form of manipulation is forbidden.
        </p>
      </section>

      <section>
        <h2>7. Payments</h2>
        <p>
          C0dify operates on a free model aimed at social welfare. If paid services are introduced, terms will be clearly stated.
        </p>
      </section>

      <section>
        <h2>8. Termination</h2>
        <p>
          Accounts violating terms may be suspended or terminated without prior notice.
        </p>
      </section>

      <section>
        <h2>9. Liability</h2>
        <p>
          C0dify provides the service “as is” without warranties. Liability is limited as permitted by law.
        </p>
      </section>

      <section>
        <h2>10. Changes</h2>
        <p>
          Terms may be updated. Continued use means acceptance of changes.
        </p>
      </section>

      <section>
        <h2>11. Governing Law</h2>
        <p>
          Disputes are governed by the laws of the platform's jurisdiction.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
